<div class="floating-filter-header">
  <lib-button
    (click)="resetColumns()"
    [img]="isDisabled() ? 'images/clear-disabled.svg' : 'images/clear.svg'"
    [disabled]="isDisabled()"
    class="grid-reset"
    [class.no-label]="!showLabel()"
  >
    @if(showLabel()) {
    <span>{{ 'GENERAL.CLEAR' | translate | uppercase }}</span>
    }
  </lib-button>
</div>
